import React from 'react'
import ClientsSlider from '../components/ClientsSlider/ClientsSlider'
import MainBanner from '../components/MainBanner/MainBanner'
import ProjectsSection from '../components/ProjectsSection/ProjectsSection'
import ServiceSection from '../components/ServiceSection/ServiceSection'
import TechnologiesSection from '../components/TechnologiesSection/TechnologiesSection'

interface HomeProps {
    
}

const Home:React.FC<HomeProps> = ({}) => {
    return (
        <div className='Home'>
            <MainBanner/>
            <ServiceSection/>
            <TechnologiesSection />
            <ProjectsSection />
            <ClientsSlider />
        </div>
    )
}

export default Home